<template>
    <div class="card">
        <div class="card-header">
            <div class="card-header__icon-wrapper">
                <mdi-icon icon="mdiBellOutline" class="card-header__icon" />
            </div>

            <div class="card-header__title">
                {{ t('home.widgets.notifications.title') }}
            </div>
        </div>

        <div v-if="notifications.lentgh" class="w-full text-center">
            <!-- @todo -->
        </div>

        <div v-else class="no-notifications">
            {{ t('home.widgets.notifications.none') }}
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });

const notifications = ref([]);
</script>

<style>
@reference "#main.css";

.card
{
    @apply min-h-[300px];
}

.no-notifications
{
    @apply mt-8 w-full text-center text-gray-500;
}
</style>
